import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zjt",
  "use": "icon-zjt-usage",
  "viewBox": "0 0 10 15",
  "content": "<symbol xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" viewBox=\"0 0 10 15\" id=\"icon-zjt\">\n<path fill-rule=\"evenodd\" fill=\"gray\" d=\"M9.626,5.300 L5.426,1.054 C5.362,0.988 5.284,0.937 5.199,0.901 C5.028,0.829 4.835,0.829 4.664,0.901 C4.578,0.937 4.501,0.988 4.436,1.054 L0.237,5.300 C-0.037,5.576 -0.037,6.024 0.237,6.300 C0.510,6.577 0.953,6.577 1.227,6.300 L4.231,3.262 L4.231,14.293 C4.231,14.684 4.545,15.000 4.931,15.000 C5.318,15.000 5.631,14.684 5.631,14.293 L5.631,3.262 L8.636,6.300 C8.773,6.439 8.952,6.508 9.131,6.508 C9.310,6.508 9.489,6.439 9.626,6.300 C9.899,6.024 9.899,5.576 9.626,5.300 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zjt.svg
// module id = M9R8
// module chunks = 12